import { User, X, History, Store, Zap, BadgePercent } from "lucide-react";
import { cn } from "@/lib/utils";
import { TRY } from "@/lib/format";
import { Combobox } from "@/components/Combobox";

// Müşteri / cari seçimi: seçili cari rozet olarak görünür; tek tıkla kaldırılıp perakendeye dönülür
export function CustomerBar({ title, contactOptions, selContact, onSelect, onClear, cariSummary, onOpenHistory, isAdmin, restricted }) {
  const has = !!String(title || "").trim();
  const type = selContact?.type;
  const chip = !has ? { label: "Perakende", cls: "bg-muted text-muted-foreground", Icon: Store }
    : type === "elektrikci" ? { label: selContact.vat_exempt ? "Elektrikçi · KDV'siz" : "Elektrikçi", cls: "bg-amber-500/15 text-amber-700 dark:text-amber-300", Icon: Zap }
      : selContact ? { label: type === "tedarikci" ? "Tedarikçi" : "Cari", cls: "bg-sky-500/15 text-sky-700 dark:text-sky-300", Icon: User }
        : { label: "Serbest isim", cls: "bg-muted text-muted-foreground", Icon: User };
  return (
    <div className="flex items-center gap-2" data-testid="pos-customer-bar">
      <div className="flex-1 min-w-0">
        <Combobox options={contactOptions} value={title} onChange={onSelect} allowCustom placeholder="Müşteri / Cari seçin — boş bırakırsanız perakende satış" searchPlaceholder="Ünvan / VKN / telefon ara…" className="h-10 rounded-xl bg-card" data-testid="qs-title" />
      </div>
      <span className={cn("hidden md:inline-flex h-10 items-center gap-1.5 rounded-xl px-2.5 text-[11px] font-bold whitespace-nowrap", chip.cls)} data-testid="pos-customer-chip">
        <chip.Icon className="h-3.5 w-3.5" />{chip.label}
      </span>
      {has && !restricted && cariSummary && cariSummary.count > 0 && (
        <button type="button" onClick={onOpenHistory} className="h-10 shrink-0 inline-flex items-center gap-1.5 rounded-xl border border-border bg-card px-2.5 text-[11px] font-bold text-sky-700 dark:text-sky-300 hover:bg-muted active:scale-[0.98] transition-all" title={isAdmin ? `${cariSummary.count} fiş · ${TRY(cariSummary.total)}` : `${cariSummary.count} önceki fiş`} data-testid="qs-cari-history-btn">
          <History className="h-3.5 w-3.5" />{cariSummary.count} geçmiş
        </button>
      )}
      {has && (
        <button type="button" onClick={onClear} className="h-10 shrink-0 inline-flex items-center gap-1.5 rounded-xl border border-destructive/30 bg-destructive/5 px-2.5 text-[11px] font-bold text-destructive hover:bg-destructive/10 active:scale-[0.98] transition-all" title="Cariyi kaldır — perakende satışa dön" data-testid="pos-clear-customer-btn">
          <X className="h-3.5 w-3.5" /><span className="hidden sm:inline">Perakendeye Dön</span>
        </button>
      )}
      {!has && selContact == null && <BadgePercent className="hidden" />}
    </div>
  );
}
